module.exports = __webpack_public_path__ + "img/Slice 268@2x(9).ae3d2b64.png";